import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Select from 'react-select';
import { makeStyles, Modal } from '@material-ui/core';
import styles from './AddNewRowToCsvPreviewForm.module.css';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../constants';
import { buildErrorMessage } from '../../apis/calls';

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const AddNewRowToCsvPreviewForm = ({
  formName,
  handleClose,
  open,
  setRecord,
  requiredParams,
  message,
  action,
}) => {
  const { showSuccess, showLoading, showInternalError } =
    usePopupManager() || true;
  const classes = useStyles();
  const [localState, setLocalState] = useState({});

  const clearData = () => {
    requiredParams.map(record => record.setValueFunction(null));
    requiredParams.map(record => record?.setHighlightField(false));
  };
  const handleCancel = () => {
    clearData();
    handleClose();
  };
  const runPreSubmitChecks = () => {
    const areValuesValid = requiredParams.map(record => {
      if (record.requiredOptions && record.value !== null) {
        const value = Object.values(record.value);
        return record.validationFunction(value[0]);
      }
      return record.validationFunction(record.value);
    });

    if (areValuesValid.some(val => val === false)) {
      return false;
    }
    return true;
  };

  const toCamelCase = str =>
    str
      .replace(/\s(.)/g, $1 => $1.toUpperCase())
      .replace(/\s/g, '')
      .replace(/^(.)/, $1 => $1.toLowerCase());

  const handleSubmit = () => {
    const values = requiredParams.map(record => {
      const object = {};
      if (record.requiredOptions) {
        object[toCamelCase(record.name)] = record.value.value;
      } else {
        object[toCamelCase(record.name)] = record.value;
      }
      return object;
    });
    let object = {};
    values.forEach(record => {
      object = { ...object, ...record };
    });
    try {
      setRecord(object);
      showSuccess({
        type: MESSAGE_TYPE.SUCCESS,
        contextText: message,
      });
    } catch (error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
    } finally {
      clearData();
      handleClose();
    }
  };

  useEffect(() => {
    const object = {};
    requiredParams.forEach(record => {
      if (record.requiredOptions) {
        object[toCamelCase(record.name)] = record?.value?.value;
      } else {
        object[toCamelCase(record.name)] = record?.value;
      }
      return object;
    });

    setLocalState(object);
  }, [requiredParams]);

  return (
    <Modal open={open} onClose={handleCancel} className={classes.modal}>
      <div className={styles.formContainer}>
        <div className={styles.formRow}>
          <div className={clsx(styles.formTitle, styles.defaultColor)}>
            <span>{formName}</span>
          </div>
        </div>
        <div className={clsx(styles.form, styles.scrollBar)}>
          {requiredParams?.map(record => (
            <div className={styles.formRow}>
              <div className={styles.firstlable}>{record.name} </div>
              {!record.requiredOptions ? (
                <span className={styles.span}>
                  <input
                    type="text"
                    name={`${record.name}`}
                    placeholder={`${record.placeholder}`}
                    className={clsx(
                      styles.dfTextArea,
                      record.highlightField && styles.mandatory,
                      styles.textArea,
                    )}
                    value={localState[toCamelCase(record.name)]}
                    onChange={e =>
                      setLocalState({
                        ...localState,
                        [toCamelCase(record.name)]: e.target.value,
                      })
                    }
                    onBlur={e => {
                      record.setValueFunction(e.target.value);
                      record.validationFunction(e.target.value);
                    }}
                    required
                    aria-label={`${record.name}`}
                    autoComplete="off"
                    readOnly={record.isReadOnly}
                  />
                  {record.isFieldValid ? (
                    <></>
                  ) : (
                    <p className={styles.errorMessage}>Invalid Type Value</p>
                  )}
                </span>
              ) : (
                <div className={styles.selectCol}>
                  <Select
                    options={record?.requiredOptions}
                    className={clsx(
                      styles.selectOptionTab,
                      record.highlightField && styles.mandatory,
                    )}
                    value={record.value}
                    onChange={e => {
                      record.setValueFunction(e);
                      record.validationFunction(e.value);
                    }}
                    placeholder={record?.placeholder}
                    aria-label={record?.name}
                    isDisabled={record?.isReadOnly}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
        <div className={styles.btContainer}>
          <button
            type="submit"
            className={styles.cancelButton}
            onClick={() => handleCancel()}
            data-testid="cancel"
          >
            Cancel
          </button>
          <button
            type="submit"
            className={styles.submitButton}
            onClick={() => {
              if (runPreSubmitChecks()) {
                showLoading();
              }
              return runPreSubmitChecks() && handleSubmit();
            }}
            data-testid="create"
          >
            {action}
          </button>
        </div>
      </div>
    </Modal>
  );
};

AddNewRowToCsvPreviewForm.propTypes = {
  formName: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setRecord: PropTypes.func.isRequired,
  requiredParams: PropTypes,
  message: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
};

export default AddNewRowToCsvPreviewForm;
